import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as sharedState from '../reducers';
import * as sharedReducer from '../reducers/get-business.reducer';

export const selectBusiness = createSelector(sharedState.GetBusinessState, sharedReducer.getBusinessResponse);
